# Deps
import Vue from 'vue'

# Zoomer, todo: get this to load only on the pdp pages
import ImageZoom from 'vue-image-zoomer'
Vue.component 'image-zoom', ImageZoom
